import React, { Component } from "react";

class ApplyFeatureProduct extends Component {
  render() {
    return <div>ApplyFeatureProduct</div>;
  }
}

export default ApplyFeatureProduct;
